import { Experiences } from '@/src/experiences'

export default Experiences.PointsToCashForMortgage.Screens.RedemptionConfirmation.Screen
